import { render, staticRenderFns } from "./AddStatusOptionPage.vue?vue&type=template&id=05a1922d&"
import script from "./AddStatusOptionPage.vue?vue&type=script&lang=js&"
export * from "./AddStatusOptionPage.vue?vue&type=script&lang=js&"
import style0 from "./AddStatusOptionPage.vue?vue&type=style&index=0&id=05a1922d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports